import { trimStart } from 'lodash';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const TrimInputSpaces = ({ children }: Props) => {
  const trimSpaces = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = trimStart(e.target.value);
  };

  return <div onInput={trimSpaces}>{children}</div>;
};
